class Amplitude {
  setUserId(userId) {
    window.amplitude.setUserId(userId)
  }

  log(eventName, eventProperties = null) {
    window.amplitude.getInstance().logEvent(eventName, eventProperties)
  }

  set(userProperties = {}) {
    window.amplitude.getInstance().setUserProperties(userProperties)
  }

  setOnce(key, value) {
    const identify = new window.amplitude.Identify().setOnce(key, value)
    window.amplitude.identify(identify)
  }
}

export default function (_, inject) {
  inject('amplitude', new Amplitude())
}
